/**
 * @fileoverview Strict comparison for Register location reference ids.
 * @module pages/register/registerReferenceIds
 */

/**
 * Compares location ids that may be stored as numbers or strings.
 * Null and undefined match only themselves.
 * @param {unknown} left
 * @param {unknown} right
 * @returns {boolean}
 */
export const referenceIdsEqual = (left, right) => {
  if (
    left === null ||
    left === undefined ||
    right === null ||
    right === undefined
  ) {
    return left === right;
  }
  return String(left) === String(right);
};
